/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-11 09:09:35
 * @LastEditTime: 2025-03-21 13:46:54
 */
export const merchBill = [
  {
    name: '提交订单',
    status: 0,
    title: '待付款'
  },
  {
    name: '付款成功',
    status: 1,
    title: '待出库'
  },
  {
    name: '商品出库',
    status: 2,
    title: '待收货'
  },
  {
    name: '等待收货',
    status: 2,
    title: '待收货'
  },
  {
    name: '交易成功',
    status: 3,
    title: '交易成功'
  }
]